export default __webpack_public_path__ + "static/media/Ironsmiter.4fe0ba19.jpg";